/*@ngInject*/
const CheckboxController = function($scope, $controller, formViewerConstant, formComponentUtil, formMediator) {

    this.checkboxValue = false;

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function() {
        this.onInit();
        this.updateCheckbox();
    };

    this.$onChanges = function() {
        this.onChanges();
        this.updateCheckbox();
    };

    this.updateCheckbox = function() {
        let fieldInstance = this.fieldStructure.fieldModel,
            uiField = this.fieldStructure.uiField,
            defaultValue = (uiField.fieldTemplate && uiField.fieldTemplate.defaultValue === 'TRUE') ? true : false;

        this.hasValue = fieldInstance ? !_.isEmpty(fieldInstance.value) : false;
        this.checkboxValue = (this.hasValue) ? (fieldInstance.value.toLowerCase() === 'true') : defaultValue;
    };


    this.handleClick = function() {
        if(this.fieldStructure.dynamicProperties.disabled) { return; }

        this.checkboxValue = !this.checkboxValue;
        this.handleChange();
    };

    this.handleChange = function() {
        this.fieldStructure.hasLocalChanges = true;

        if(this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel.value = (this.checkboxValue) ? 'true' : 'false';
        } else {
            this.fieldStructure.fieldModel = { value: (this.checkboxValue) ? 'true' : 'false' };
        }

        formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    };

    this.getRowRepeaterFieldWidth = function () {
        let isRowRepeater = this.hideLabel,
            padding = isRowRepeater ? 12 : 0,
            inputWidth = this.fieldStructure.layout.inputWidth + padding;

        return isRowRepeater ? inputWidth : 'auto';
    };
};

angular.module('umFormViewer')
    .controller('checkboxController', CheckboxController);
